module.exports = __webpack_public_path__ + "img/q23c3c-l8.prt.668bf9e6.jpg";